import * as yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { FormItemGeneral } from '../abm/actividades/FormItemGeneral';

const schema = yup.object().shape({
  importe: yup.number().positive().required().label("Importe"),
  concepto: yup.string().required().label("Concepto"),
  id_moneda: yup.number().required().label("Moneda")
});

export const ModalActividadesEditItemGeneral = ({showState = [false, ()=>{}], selectedItem, abmActions, showNotification, loadDetails, idItem}) => {

  const [data, setData] = useState({});
  const [item, setItem] = useState({});
  const [show, setShow] = showState;
  const formRef = useRef();

  const loads = () => {
    abmActions.getAll({}, "monedas/options")
      .then(response => {
        setData(data => ({...data, monedas: response.results}));
      })
      .catch(reason => {
        console.warn(reason);
      });
    abmActions.getOne(idItem, "items_generales")
      .then(response => {
        setItem(response);
      })
      .catch(reason => {
        console.warn(reason);
      });
  }
  
  useEffect(()=>{
    show && loads();
  }, [show])


  const handleCancel = () => {
    setShow(false);
  }

  const handleConfirm = (data) => {
    abmActions.update(data, idItem, "items_generales").then(result => {
      loadDetails(selectedItem.id);
      setShow(false);
    }).catch(error=>{
      error.json().then(result => {
        showNotification({message: result.messages.map(m => <div className="notification-item">{m}</div>) || "Error creando registro"});
      })
    });
  }

  return (
    <>
      <Dialog open={show} onClose={handleCancel} keepMounted={false} PaperProps={{sx: {overflow: "visible"}}}>
        <DialogTitle>Editar item de presupuesto general</DialogTitle>
        <DialogContent sx={{overflow: "visible"}}>
          <FormItemGeneral
            ref={formRef}
            item={item}
            data={data}
            schema={schema} 
            onConfirm={handleConfirm} 
            loads={loads}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="success" onClick={e => formRef.current.submit(e)}>
            Guardar
          </Button>      
          <Button variant="outlined" color="error" onClick={handleCancel}>
            Cancelar
          </Button>   
        </DialogActions>
      </Dialog>
    </>
  )
}